function isContactLensesOrderLineItem(orderLineItem) {
    return 'eyeSide' in orderLineItem;
}
function isContactLensesBundleOrderLineItem(orderLineItem) {
    return 'bundledLineItems' in orderLineItem;
}
function isBundleChildContactLensesLineItem(bundleLineItem) {
    return 'eyeSide' in bundleLineItem;
}
function isNonPrescriptionBundleOrderLineItem(orderLineItem) {
    return 'configurationDetails' in orderLineItem && !('prescription' in orderLineItem);
}
function isGlassesBundleOrderLineItem(orderLineItem) {
    return 'configurationDetails' in orderLineItem && 'prescription' in orderLineItem;
}
function isSolutionOrderLineItem(orderLineItem) {
    return 'product' in orderLineItem && 'volume' in orderLineItem.product;
}
function isSupportedLineItem(orderLineItem) {
    return orderLineItem.__typename !== 'OrderLineItemSubscription';
}

export { isBundleChildContactLensesLineItem, isContactLensesBundleOrderLineItem, isContactLensesOrderLineItem, isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem, isSolutionOrderLineItem, isSupportedLineItem };
//# sourceMappingURL=order-line-item-product-type-guards.js.map
